import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, ArrowRight, Shield } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { loginWithGoogle } from '../utils/auth';

export const AuthRedirectPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleContinueWithGoogle = async () => {
        setLoading(true);
        try {
            const result = await loginWithGoogle();
            if (!result.success) {
                alert(result.error || 'Error al conectar con Google');
                setLoading(false);
            }
        } catch (error) {
            console.error('Login error:', error);
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-background via-background to-secondary/20 flex items-center justify-center p-4">
            <Card className="w-full max-w-md p-8 text-center shadow-2xl border-2 border-primary/10">
                <div className="mb-8">
                    <div className="w-20 h-20 bg-primary/10 rounded-3xl flex items-center justify-center mx-auto mb-6">
                        <ShieldCheck className="w-12 h-12 text-primary" />
                    </div>
                    <h1 className="text-3xl font-black mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                        Autenticación Segura
                    </h1>
                    <div className="space-y-4 text-muted-foreground text-balanced">
                        <p>
                            Estás a un paso de entrar a **Tetris Bíblico**.
                        </p>
                        <p className="text-sm bg-secondary/30 p-4 rounded-2xl border border-secondary/50">
                            Te vamos a redirigir a nuestro proveedor de autenticación seguro (**Supabase**) para iniciar sesión con **Google**, y luego volverás automáticamente al juego.
                        </p>
                    </div>
                </div>

                <div className="space-y-4">
                    <Button
                        onClick={handleContinueWithGoogle}
                        disabled={loading}
                        className="w-full h-16 text-lg font-bold bg-[#4285F4] hover:bg-[#357abd] text-white rounded-2xl shadow-lg transition-all active:scale-95 flex items-center justify-center gap-3"
                    >
                        {loading ? (
                            <div className="w-6 h-6 border-3 border-white border-t-transparent rounded-full animate-spin"></div>
                        ) : (
                            <>
                                <svg className="w-6 h-6" viewBox="0 0 24 24">
                                    <path
                                        fill="currentColor"
                                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                                    />
                                    <path
                                        fill="currentColor"
                                        fillOpacity="0.8"
                                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                                    />
                                    <path
                                        fill="currentColor"
                                        fillOpacity="0.6"
                                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                                    />
                                    <path
                                        fill="currentColor"
                                        fillOpacity="0.8"
                                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                                    />
                                </svg>
                                Continuar con Google
                            </>
                        )}
                    </Button>

                    <button
                        onClick={() => navigate('/login')}
                        className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors flex items-center justify-center gap-2 mx-auto"
                    >
                        Volver al inicio de sesión clásico
                    </button>
                </div>

                <div className="mt-8 pt-6 border-t border-border flex items-center justify-center gap-2 text-xs text-muted-foreground">
                    <Shield className="w-3 h-3" />
                    Tus datos están protegidos por Supabase & Google
                </div>
            </Card>
        </div>
    );
};
